import Cookie from "js-cookie"
export default {
    namespaced: true,
    state: {
        isCollapse: false,//控制导航菜单展开还是收起
        //面包屑数据
        tabsList: [
            {
                path: "/",
                name: "home",
                label: "首页",
                icon: "s-home",
                url: "Home/Home",
            }
        ]
    },
    actions: {},
    mutations: {
        //修改菜单展开状态
        collapseMenu(state) {
            state.isCollapse = !state.isCollapse
        },
        //修改tag数据
        selectMenu(state, route) {
            //判断添加的数据是否为首页
            if (route.name !== 'home') {
                const index = state.tabsList.findIndex(item => item.name === route.name)
                if (index === -1) {
                    state.tabsList.push(route)
                }
            }
        },
        //重置tag数据
        resetMenu(state) {
            state.tabsList = [
                {
                    path: "/",
                    name: "home",
                    label: "首页",
                    icon: "s-home",
                    url: "Home/Home",
                }
            ]
        },
        //删除指定的tag数据
        closeTag(state, item) {
            const index = state.tabsList.findIndex(it => it.name === item.name)
            state.tabsList.splice(index, 1)
        }
    }
}